<template>
    <div class="l-rblock">
        <l-tree-select v-if="isLoadByCompany" v-model="selectValue" :options="departmentOptions"
            :placeholder="$t(placeholder)" :size="size" :disabled="disabled" :clearable="disabled ? false : clearable"
            @change="handleChange">
            <template #prefix v-if="canSelectCurrent && !disabled">
                <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)"
                    @click.stop="selectCurrent">
                    <i class="learun-icon-lock" :style="{ 'color': hasCurrent ? '#0D68FF' : '#8c8c8c' }"></i>
                </div>
            </template>
        </l-tree-select>
        <template v-else>
            <template v-if="mode == 'normal'">
                <span v-if="disabled && printMode">{{ showValue }}</span>
                <el-input v-else ref="main" :placeholder="$t(placeholder)" v-model="showValue" :size="size"
                    :clearable="disabled ? false : clearable" :disabled="disabled" style="vertical-align: middle;"
                    @clear="handleInputClear" @focus="handleShow">
                    <span slot="append" @click="handleShow">
                        <el-button slot="append" icon="learun-icon-department"></el-button>
                    </span>
                    <template slot="prepend" v-if="canSelectCurrent && !disabled">
                        <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)"
                            @click.stop="selectCurrent">
                            <i class="learun-icon-lock" :style="{ 'color': hasCurrent ? '#0D68FF' : '#8c8c8c' }"></i>
                        </div>
                    </template>
                </el-input>

            </template>
            <template v-else-if="mode == 'form'">
                <div class="flex" style="flex-wrap: wrap;">
                    <div class="add-btn" style="
                        width: auto;
                        padding: 0 12px;
                        display: inline-block;
                        font-size: 12px;
                        color: #2c71fa;
                        background: #f5f7f9;
                        height: 28px;
                        line-height: 28px;
                        border-radius: 14px;
                        margin: 4px 0;
                        margin-right: 8px;
                        cursor: pointer;" @click="handleShow" v-if="!disabled">
                        <i class="el-icon-plus"></i>
                        {{ $t('添加部门') }}
                    </div>
                    <l-department :canRemove="!disabled" mode="form" @remove="removeHandler"
                        v-for="i in departments.slice(0, 10)" :value="i" :key="i" />
                    <span v-if="departments.length > 10" class="pointer" @click.stop="handleShow">等{{ departments.length
                    }}个部门</span>
                </div>
            </template>
            <template v-else-if="mode == 'tag'">
                <div class="flex tag-mode" @click="handleShow" :style="{ 'border-width': showBorder ? '1px' : '0px' }">
                    <template v-if="departments.length > 0">
                        <l-department :canRemove="!disabled" mode="form" @remove="removeHandler"
                            v-for="i in departments.slice(0, 10)" :value="i" :key="i" />
                        <span v-if="departments.length > 10" class="pointer" @click.stop="handleShow">等{{
                            departments.length }}个部门</span>
                    </template>

                    <div class="tishi" v-if="showPlaceholder && departments.length == 0">
                        <i class="el-icon-plus" style="font-size: 13px;margin-right: 2px;"></i>
                        <span style="font-size: 12px;">请选择部门</span>
                    </div>


                </div>
            </template>
        </template>
        <l-dialog v-if="!isLoadByCompany" :title="$t(placeholder)" :visible.sync="dialogVisible" :height="480"
            :hasBtns="multiple" @ok="handleSelectMultiple" @opened="handleOpened" width="600px">
            <l-layout class="l-tab-page" :left="300">
                <template #left>
                    <l-panel :title="$t('公司信息')" style="padding-right:0;">
                        <el-tree ref="companyTree" :data="companyTree" node-key="f_CompanyId" default-expand-all
                            :expand-on-click-node="false" @node-click="handleCompanyClick">
                            <span slot-scope="{ node}">
                                {{ $t(node.label) }}
                            </span>
                        </el-tree>
                    </l-panel>
                </template>
                <l-panel :title="$t('部门信息')" style="padding-left:0;">
                    <template #toolLeft>
                        <div class="l-panel--item" style="width: 100%;">
                            <el-input :placeholder="$t('请输入')" clearable @change="searchWordChange(true)"
                                v-model="searchWord" @input="searchWordChange()" size="mini">
                                <el-button slot="append" icon="el-icon-search"
                                    @click="searchWordChange(true)"></el-button>
                            </el-input>
                        </div>
                    </template>
                    <VueEasyTree height="100%" style="height: 100%;overflow: auto;" :itemSize="40"
                        :data="departmentsTree" :show-checkbox="multiple" ref="maintree" node-key="f_DepartmentId"
                        :check-strictly="true" :check-on-click-node="true" :render-after-expand="true"
                        :filter-node-method="fliterMethod" @node-click="handleDepartmentClick"
                        @check-change="handleCheckChange">
                        <span slot-scope="{node}">
                            {{ $t(node.label) }}
                        </span>
                    </VueEasyTree>
                    <!-- <el-tree :data="departmentsTree" :check-strictly="true" :check-on-click-node="true" :show-checkbox="multiple"
                         ref="maintree" node-key="f_DepartmentId" :render-after-expand="true"
                         :filter-node-method="fliterMethod" @node-click="handleDepartmentClick">
                        <span slot-scope="{node}">
                            {{ $t(node.label) }}
                        </span>
                    </el-tree> -->
                </l-panel>
            </l-layout>
        </l-dialog>
    </div>
</template>

<script>
import VueEasyTree from '@wchbrad/vue-easy-tree';
export default {
    name: 'l-department-select',
    components: {
        VueEasyTree
    },
    props: {
        value: {},
        size: {
            type: String,
            default: 'mini'
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        companyId: {
            type: String,
            default: ''
        },
        isLoadByCompany: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        mode: {
            default: 'tag', //form、normal
        },
        printMode: {
            default: false
        },
        canSelectCurrent: {
            default: false
        },
        showBorder: {
            default: true
        },
        showPlaceholder: {
            default: true
        },
        defaultCompanyId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            selectCompanyId: '',

            text: '',
            searchWord: '',
            currentName: '所属部门'
        }
    },
    computed: {
        selectValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        departmentOptions() {
            if (this.lr_departments) {
                return this.lr_departmentTree(this.lr_departments[this.companyId])
            }
            else {
                return []
            }
        },
        hasCurrent() {
            if (!this.value) return false
            return this.value.indexOf(this.currentName) > -1
        },
        uidStr() {
            if (!this.vlaue) return ''
            return this.value.replace(`${this.currentName},`, '').replace(this.currentName, '')
        },
        departments() {
            return this.value ? this.value.split(',') : []
        },

        showValue: {
            get() {
                let arr = this.value ? this.value.split(',') : [], brr = []
                if (arr.includes(this.currentName)) {
                    brr.push(this.$t(this.currentName))
                }
                if (this.lr_departmentNameByOne) {
                    brr = brr.concat(this.lr_departmentNameByOne(arr.filter(e => e != this.currentName).join(',')))
                }
                else {
                    return this.value
                }
                return brr.filter(e => e).join(',')
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        companyTree() {
            if (this.lr_companyTree) {
                return this.lr_companyTree
            }
            else {
                return []
            }
        },
        departmentList() {
            return this.lr_departments[this.selectCompanyId]
        },
        departmentsTree() {
            if (this.lr_departments) {
                return this.lr_departmentTree(this.departmentList)
            }
            else {
                return []
            }
        }
    },
    created() {
        this.lr_loadCompanys && this.lr_loadCompanys()
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) newVal = newVal.replace(`${this.currentName},`, '').replace(this.currentName, '')
                if (!this.$validatenull(newVal)) {
                    this.lr_loadDepartment && this.lr_loadDepartment(newVal)
                }
            },
            immediate: true
        }
    },
    methods: {

        searchWordChange(searchNow) {
            if (searchNow) return this.$refs.maintree && this.$refs.maintree.filter(this.searchWord)
            this.$lastOpt('userSelectSearchChange', () => {
                this.$refs.maintree && this.$refs.maintree.filter(this.searchWord)
            }, 500)
        },
        fliterMethod(value, data) {
            if (!data) return false
            if (!value) return true
            let val = value.toLocaleLowerCase()
            let str = data.f_FullName || ''
            if (str.toLocaleLowerCase().includes(val)
                || data.filter
                || window.Mtils.utils.makePy(str, true).toLocaleLowerCase().includes(val)
                || window.Mtils.utils.makePy(str).toLocaleLowerCase().includes(val)) {
                data.children && data.children.forEach((e, index) => {
                    e.filter = true
                })
                return true
            } else {
                data.children && data.children.forEach((e, index) => {
                    e.filter = false
                })
            }
            return false
        },
        selectCurrent() {
            let arr = this.value ? this.value.split(',') : []
            if (arr.includes(this.currentName)) {
                arr = arr.filter(e => e != this.currentName)
            } else {
                if (this.multiple) {
                    arr.unshift(this.currentName)
                } else {
                    arr = [this.currentName]
                }
            }
            let val = arr.join(',')
            this.$emit('input', val)
            this.$emit('change', val)
        },
        removeHandler(id) {
            let arr = this.value ? this.value.split(',') : []
            arr = arr.filter(e => e != id)
            this.$emit('input', arr.join(','))
            this.handleChange(arr.join(','))
        },
        handleChange(val) {
            // 主动触发 el-form-item 的校验状态更新
            // 通过 dispatch 向上查找 el-form-item 并触发校验
            if (this.$parent && this.$parent.$options && this.$parent.$options.componentName === 'ElFormItem') {
                this.$parent.$emit('el.form.change', val)
            }
            this.$emit('change', val)
        },

        handleShow() {
            if (!this.disabled) {
                this.dialogVisible = true
                this.$nextTick(() => {
                    console.log(this.lr_companyTree, 'lr_companyTree')
                    console.log(this.selectCompanyId, 'selectCompanyId')
                    if (!this.selectCompanyId && (this.lr_companyTree && this.lr_companyTree.length > 0) || this.defaultCompanyId) {
                        const firstCompany = this.lr_companyTree[0]
                        this.selectCompanyId = this.defaultCompanyId || firstCompany.f_CompanyId
                        console.log(this.selectCompanyId, 'selectCompanyId')
                        this.$nextTick(() => {
                            this.$refs.companyTree && this.$refs.companyTree.setCurrentKey(this.selectCompanyId)
                            this.lr_loadDepartments && this.lr_loadDepartments(this.selectCompanyId)
                        })
                    }
                })
            }
        },
        handleCompanyClick(node) {
            this.selectCompanyId = node.f_CompanyId || node.id
            this.lr_loadDepartments && this.lr_loadDepartments(this.selectCompanyId)
            this.$nextTick(() => {
                setTimeout(() => {
                    this.searchWord && this.searchWordChange(true)
                }, 300);
            })
        },
        handleCheckChange(data, checked, indeterminate) {
            // checked: 节点本身是否被选中（boolean）
            // indeterminate: 节点的子树中是否有被选中的节点

            const node = this.$refs.maintree.getNode(data);

            if (checked && node.childNodes && node.childNodes.length > 0) {
                this.setChildrenChecked(node, true);
            } else if (!checked && node.childNodes && node.childNodes.length > 0) {
                this.setChildrenChecked(node, false);
            }
        },
        setChildrenChecked(node, isChecked) {
            node.childNodes.forEach(child => {
                this.$refs.maintree.setChecked(child, isChecked);
                if (child.childNodes && child.childNodes.length > 0) {
                    this.setChildrenChecked(child, isChecked);
                }
            });
        },
        handleDepartmentClick(node) {
            if (this.multiple) return
            this.lr_loadDepartment && this.lr_loadDepartment(node.f_DepartmentId)
            this.selectValue = node.f_DepartmentId
            // 关闭弹窗前主动触发 input blur，确保 el-form-item 校验状态更新
            this.triggerInputBlur()
            this.$nextTick(() => {
                this.dialogVisible = false
                this.handleChange(node)
            })

        },
        handleInputClear() {
            this.handleChange()
        },
        // 主动触发 input blur，确保 el-form-item 校验状态更新
        triggerInputBlur() {
            // 尝试触发 el-input 的 blur 事件
            const inputRef = this.$refs.main
            if (inputRef && inputRef.$refs && inputRef.$refs.input) {
                inputRef.$refs.input.blur()
            } else if (inputRef && inputRef.blur) {
                inputRef.blur()
            }
            // 同时向上冒泡触发 blur
            if (this.$el && this.$el.querySelector) {
                const input = this.$el.querySelector('input')
                if (input) {
                    input.blur()
                }
            }
            // 向上触发 el.form.change 事件，确保 el-form-item 重新校验
            let parent = this.$parent
            while (parent) {
                if (parent.$options && parent.$options.componentName === 'ElFormItem') {
                    parent.$emit('el.form.change', this.value)
                    break
                }
                parent = parent.$parent
            }
        },
        handleOpened() {
            if (this.value) {
                this.$refs.maintree && this.$refs.maintree.setCheckedKeys(this.value.split(','), true)
            }
            else {
                this.$refs.maintree.setCheckedKeys([])
            }
        },
        handleSelectMultiple() {
            const checkedKeys = this.$refs.maintree.getCheckedKeys()
            const selectValue = checkedKeys
            if (this.hasCurrent) {
                selectValue.unshift(this.currentName)
            }
            this.selectValue = String(selectValue)
            // 关闭弹窗前主动触发 input blur，确保 el-form-item 校验状态更新
            this.triggerInputBlur()
            this.$nextTick(() => {
                this.dialogVisible = false
                if (!this.selectValue) {
                    this.handleChange()
                }
                else {
                    this.handleChange(this.departmentList.filter(t => selectValue.indexOf(t.f_DepartmentId) != -1))
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.tishi {
    height: 20px;
    line-height: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: bottom;
    margin-bottom: -1px;
    position: absolute;
}

.add-btn {
    width: auto;
    padding: 0 12px;
    display: inline-block;
    font-size: 12px;
    color: #2c71fa;
    background: #f5f7f9;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    margin-right: 10px;
    margin: 4px 0;
    margin-right: 8px;
    cursor: pointer;
}

.tag-mode {
    display: inline-flex;
    min-width: 165px;
    vertical-align: top;
    width: 100%;
    flex-wrap: wrap;
    border: 1px dashed #bfbfbf;
    border-radius: 4px;
    height: 28px;
    cursor: pointer;
    padding: 2px 3px;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 4px;

}

::v-deep {
    .tag-mode {
        .remove-btn {
            transform: scale(0.8);
            top: -13px;
            line-height: 21px;
        }

        .tag-item.isForm {
            height: 22px !important;
            margin: 0;
            border-radius: 3px;
            padding-left: 5px;
            padding-right: 5px;
            font-size: 12px;
            line-height: 22px;
            padding-right: 5px;
            color: #000;
        }

        .tag-item .name {
            padding-right: 0;
            line-height: 22px;
        }

        .tag-right {
            line-height: 22px;
            width: unset !important;
        }

        .tag-item .avatar {
            margin-right: 4px;
        }
    }

}
</style>
